import * as React from 'react';
import { CallToAction } from '../../types/blocks/carousel';
import { CallToActionButton } from '../elements/call-to-action-button';

interface SectionAppStoresBannerProps {
  ctaButtons: CallToAction[];
  className?: string;
  ctaClassName?: string;
}

export const SectionAppStoresBanner: React.FC<SectionAppStoresBannerProps> = ({
  ctaButtons,
  className,
  ctaClassName,
}) =>
  !!ctaButtons?.length && (
    <div className={`flex flex-wrap sm:flex-nowrap md:gap-x-4 gap-2 py-4 ${className}`}>
      {ctaButtons.map((btn) => (
        <CallToActionButton button={btn} key={btn.id} className={ctaClassName} target="_blank" />
      ))}
    </div>
  );
